<template>
  <div class="wrap">
     <van-nav-bar
      left-text="返回"
      left-arrow
      @click-left="$router.push('/')"
    />
    <img src="../assets/images/FoundWinnersTop.png" class="wrap_img" />
    <div class="found_winner">
      <div class="stock_list" style="padding-left: 22px">
        <van-row style="display: flex; align-items: center">
          <van-col span="12">
            <p style="font-size: 16px; font-weight: 700">每日资讯</p>
          </van-col>
          <van-col span="12" style="text-align: right">
            <p style="font-size: 16px; color: black" @click="newsInfo(1)">
              更多<van-icon name="arrow" />
            </p>
          </van-col>
        </van-row>

        <van-row>
          <van-col :span="2">
            <div>
              <img src="../assets/images/newscategory2.png" />
            </div>
          </van-col>
          <van-col :span="1">
            <span style="color: red; font-size: 14px">早</span>
          </van-col>
          <van-col :span="1">
            <span></span>
          </van-col>
          <van-col :span="1">
            <span></span>
          </van-col>
          <van-col :span="1">
            <span style="color: red; font-size: 14px">评</span>
          </van-col>
          <van-col :span="1"> </van-col>
          <van-col :span="15">
            <span style="font-size: 14px">{{
              newsCategories[2] ? newsCategories[2] : ""
            }}</span>
          </van-col>
          <van-col :span="2">
            <img src="../assets/images/arrow.png" @click="newsInfo(2)" />
          </van-col>
        </van-row>
        <van-divider style="margin-top: 8px" />

        <van-row>
          <van-col :span="2">
            <div>
              <img src="../assets/images/newscategory3.png" />
            </div>
          </van-col>
          <van-col :span="1">
            <span style="color: red; font-size: 14px">盘</span>
          </van-col>
          <van-col :span="1">
            <span style="color: red; font-size: 14px">中</span>
          </van-col>
          <van-col :span="1">
            <span style="color: red; font-size: 14px">解</span>
          </van-col>
          <van-col :span="1">
            <span style="color: red; font-size: 14px">盘</span>
          </van-col>
          <van-col :span="1"> </van-col>
          <van-col :span="15">
            <span style="font-size: 14px">{{
              newsCategories[3] ? newsCategories[3] : ""
            }}</span>
          </van-col>
          <van-col :span="2">
            <img src="../assets/images/arrow.png" @click="newsInfo(3)" />
          </van-col>
        </van-row>
        <van-divider style="margin-top: 8px" />

        <van-row>
          <van-col :span="2">
            <div>
              <img src="../assets/images/newscategory4.png" />
            </div>
          </van-col>
          <van-col :span="1">
            <span style="color: red; font-size: 14px">收</span>
          </van-col>
          <van-col :span="1">
            <span></span>
          </van-col>
          <van-col :span="1">
            <span></span>
          </van-col>
          <van-col :span="1">
            <span style="color: red; font-size: 14px">评</span>
          </van-col>
          <van-col :span="1"> </van-col>
          <van-col :span="15">
            <span style="font-size: 14px">{{
              newsCategories[4] ? newsCategories[4] : ""
            }}</span>
          </van-col>
          <van-col :span="2">
            <img src="../assets/images/arrow.png" @click="newsInfo(4)" />
          </van-col>
        </van-row>
      </div>
      <div class="stock_list" style="padding: 0">
        <van-row>
          <van-col span="6">
            <a href="javascript:void(0);" @click="getCode(1)">
              <div
                class="winner_flag"
                v-bind:class="activeTab == 1 ? 'activeTabRedFirst' : ''"
              >
                <img
                  v-if="activeTab == 1"
                  src="../assets/images/classifyOneActive.png"
                />

                <img v-else src="../assets/images/classifyOne.png" />
                <span class="winner_para">短线宝</span>
              </div>
            </a>
          </van-col>
          <van-col span="6">
            <a href="javascript:void(0);" @click="getCode(2)">
              <div
                class="winner_flag"
                v-bind:class="activeTab == 2 ? 'activeTabRed' : ''"
              >
                <img
                  v-if="activeTab == 2"
                  src="../assets/images/classifyTwoActive.png" 
                />
                <img v-else src="../assets/images/classifyTwo.png" 
                />
                <span class="winner_para">牛人牛股</span>
              </div>
            </a>
          </van-col>
          <van-col span="6">
            <a href="javascript:void(0);" @click="getCode(3)">
              <div
                class="winner_flag"
                v-bind:class="activeTab == 3 ? 'activeTabRed' : ''"
              >
                <img
                  v-if="activeTab == 3"
                  src="../assets/images/classifyThreeActive.png"
                />
                <img v-else src="../assets/images/classifyThree.png" />
                <span class="winner_para">问财神</span>
              </div>
            </a>
          </van-col>
          <van-col span="6">
            <a href="javascript:void(0);" @click="getCode(4)">
              <div
                class="winner_flag"
                style="border: none"
                v-bind:class="activeTab == 4 ? 'activeTabRedLast' : ''"
              >
                <img
                  v-if="activeTab == 4"
                  src="../assets/images/classifyFourActive.png" />
                <img v-else src="../assets/images/classifyFour.png" />
                <span class="winner_para">尾盘追击</span>
              </div>
            </a>
          </van-col>
        </van-row>
      </div>

      <div class="stock_list">
        <van-row style="padding-left: 16px">
          <van-col span="12">
            <p style="font-size: 16px; font-weight: 700">最近股票池</p>
          </van-col>
          <van-col span="12" style="text-align: right">
            <p
              style="font-size: 16px; color: black"
              @click="isLogin('stock_today')"
            >
              更多<van-icon name="arrow" />
            </p>
          </van-col>
        </van-row>

        <div class="found_winner_title">
          <van-row>
            <van-col span="6">
              <h4>股票名</h4>
            </van-col>
            <van-col span="6">
              <h4>关注价</h4>
            </van-col>
            <van-col span="6">
              <h4>最高价</h4>
            </van-col>
            <van-col span="6">
              <h4>最大涨幅</h4>
            </van-col>
          </van-row>
          <van-divider style="margin-top: 8px" />
        </div>
        <div v-for="(item, index) in stock_today.slice(0, 3)" :key="index">
          <van-row>
            <van-col :span="6">
              <div class="stock_name" @click="onClickLoginReadable(item)">
                <p v-if="$store.state.loginType">{{ item.stock_name }}</p>
                <p v-if="$store.state.loginType">{{ item.stock_code }}</p>
                <router-link to="/login" v-else style="color: #333">
                  <p>登录可读</p>
                </router-link>
              </div>
            </van-col>
            <van-col :span="6">
              <div class="stock_details">
                <p>{{ item.focus_price }}</p>
                <p>{{ item.focus_time }}</p>
              </div>
            </van-col>
            <van-col :span="6">
              <div class="stock_details">
                <p>{{ item.high_price }}</p>
                <p>{{ item.high_time }}</p>
              </div>
            </van-col>
            <van-col :span="6">
              <div class="stock_details red" v-if="item.stock_status != 1">
                {{ (Number(item.changepercent) * 100).toFixed(2) }}%
              </div>
              <div class="stock_details red" v-else>- -</div>
            </van-col>
          </van-row>
          <van-divider style="margin-top: 8px" />
        </div>
      </div>
      <div style=" padding: 0px 20px 0px 10px;">
        <van-row style="padding-left: 16px">
          <van-col span="12">
            <p style="font-size: 16px; font-weight: 700;color:red">温馨提示！</p>
          </van-col>
      
        </van-row>
        <van-row style="padding-left: 16px">
          <van-col span="24">
            <h4 style="font-size: 14px; font-weight: bold;color: black">股票资讯不构成买卖建议，仅供参考！如有疑问咨询专属客服！</h4>
          </van-col>
      
        </van-row>
      </div>
      <div class="stock_list">
        <van-row style="padding-left: 15px">
          <van-col span="12">
            <p style="font-size: 16px; font-weight: 700">近15日排行版</p>
          </van-col>
          <van-col span="12" style="text-align: right">
            <p
              style="font-size: 16px; color: black"
              @click="isLogin('stock_history')"
            >
              更多<van-icon name="arrow" />
            </p>
          </van-col>
        </van-row>
        <div class="found_winner_title">
          <van-row>
            <van-col :span="6">
              <h4>股票名</h4>
            </van-col>
            <van-col :span="6">
              <h4>关注价</h4>
            </van-col>
            <van-col :span="6">
              <h4>最高价</h4>
            </van-col>
            <van-col :span="6">
              <h4>最大涨幅</h4>
            </van-col>
          </van-row>
          <van-divider style="margin-top: 8px" />
        </div>
        <div v-for="(item, index) in stock_history.slice(0, 5)" :key="index">
          <van-row>
            <van-col :span="6">
              <div class="stock_name" @click="onClickLoginReadable(item)">
                <p v-if="$store.state.loginType">{{ item.stock_name }}</p>
                <p v-if="$store.state.loginType">{{ item.stock_code }}</p>
                <router-link to="/login" v-else style="color: #333">
                  <p>登录可读</p>
                </router-link>
              </div>
            </van-col>
            <van-col :span="6">
              <div class="stock_details">
                <p>{{ item.focus_price }}</p>
                <p class="van-ellipsis">{{ item.focus_time }}</p>
              </div>
            </van-col>
            <van-col :span="6">
              <div class="stock_details">
                <p>{{ item.high_price }}</p>
                <p class="van-ellipsis">{{ item.high_time }}</p>
              </div>
            </van-col>
            <van-col :span="6">
              <div class="stock_details red" v-if="item.stock_status != 1">
                {{ (Number(item.changepercent) * 100).toFixed(2) }}%
              </div>
              <div class="stock_details red" v-else>- -</div>
            </van-col>
            <van-divider style="margin-top: 8px" />
          </van-row>
          <van-divider style="margin-top:8px;" />

        </div>
      </div>
    </div>
    <van-popup v-model="stock_today_status" class="stockPopup" closeable>
      <h3 style="padding-left: 10px; text-align: center">最新股票池</h3>
      <div class="stock_more">
        <table class="stock_th" cellspacing="0" cellpadding="0" border="0">
          <tr>
            <th>股票名</th>
            <th>关注价</th>
            <th>最高价</th>
            <th>最大涨幅</th>
          </tr>
          <tr
            v-for="(item, index) in stock_today"
            :key="index"
            class="stock_td"
          >
            <td>
              <p
                @click="
                  $router.push({
                    name: 'Kline',
                    params: { code: item.stock_code },
                  })
                "
              >
                {{ item.stock_name }}
              </p>
              <p>{{ item.stock_code }}</p>
            </td>
            <td>
              <p>{{ item.focus_price }}</p>
              <p>{{ item.focus_time }}</p>
            </td>
            <td>
              <p>{{ item.high_price }}</p>
              <p>{{ item.high_time }}</p>
            </td>
            <td>
              <p v-if="item.stock_status != 1">
                {{ (Number(item.changepercent) * 100).toFixed(2) }}%
              </p>
              <p v-else>- -</p>
            </td>
          </tr>
        </table>
      </div>

      <van-button
        size="large"
        color="red"
        @click="close()"
        style="
          width: 30%;
          margin-right: 5%;
          height: 30%;
          padding: 15px;
          margin-top: 10px;
          border-radius: 20px;
          float: right;
        "
        >取消
      </van-button>
    </van-popup>
    <van-popup v-model="stock_history_status" class="stockPopup" closeable>
      <h3 style="padding-left: 10px">近15日涨幅排行榜</h3>
      <div class="stock_more">
        <table class="stock_th" cellspacing="0" cellpadding="0" border="0">
          <tr>
            <th>股票名</th>
            <th>关注价</th>
            <th>最高价</th>
            <th>最大涨幅</th>
          </tr>
          <tr
            v-for="(item, index) in stock_history"
            :key="index"
            class="stock_td"
          >
            <td>
              <p
                @click="
                  $router.push({
                    name: 'Kline',
                    params: { code: item.stock_code },
                  })
                "
              >
                {{ item.stock_name }}
              </p>
              <p>{{ item.stock_code }}</p>
            </td>
            <td>
              <p>{{ item.focus_price }}</p>
              <p>{{ item.focus_time }}</p>
            </td>
            <td>
              <p>{{ item.high_price }}</p>
              <p>{{ item.high_time }}</p>
            </td>
            <td>
              <p v-if="item.stock_status != 1">
                {{ (Number(item.changepercent) * 100).toFixed(2) }}%
              </p>
              <p v-else>- -</p>
            </td>
          </tr>
        </table>
      </div>
      <van-button
        size="large"
        color="red"
        @click="close()"
        style="
          width: 30%;
          margin-right: 5%;
          height: 30%;
          padding: 15px;
          margin-top: 10px;
          border-radius: 20px;
          float: right;
        "
        >取消
      </van-button>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "FoundWinners",
  data() {
    return {
      stock_today: "",
      stock_today_status: false,
      stock_history: "",
      stock_history_status: false,
      activeColor: "red",
      description: 1,
      newsCategories: "",
      activeTab: 1,
    };
  },
  methods: {
    newsInfo(category) {
      window.sessionStorage.setItem("newsCatId", category);
      this.$router.push({
        path: "/news_info",
      });
    },
    getNewsCategory() {
      let that = this;
      that
        .$http({
          url: "/", //请求地址
          method: "post",
          data: {
            nozzle: "news_category",
          },
        })
        .then((ret) => {
          let resData = ret.data;
          if (resData.code === 1) {
            that.newsCategories = resData.data;
          } else {
          }
        });
    },
    getCode(classify) {
      let that = this;
      that.description = classify;
      that.activeTab = classify;
      that
        .$http({
          url: "/", //请求地址
          method: "post",
          data: {
            nozzle: "found_winner",
            action: "found_winner_new",
            classify: classify,
          },
        })
        .then((ret) => {
          let resData = ret.data;
          if (resData.code === 1) {
            let data = resData.data;
            that.stock_today = data.active_stocks;
            that.stock_history = data.disabled_stocks;
          } else {
          }
        });
    },
    onClickLoginReadable(item) {
      if (this.$store.state.loginType) {
        console.log("shdjbsjhjsdf");
        this.$router.push({ name: "Kline", params: { code: item.stock_code } });
      } else {
        this.$router.push("/login");
      }
    },
    isLogin(type) {
      let that = this;
      if (this.$store.state.loginType) {
        switch (type) {
          case "stock_today":
            that.stock_today_status = true;
            break;
          case "stock_history":
            that.stock_history_status = true;
            break;
        }
      } else {
        that.$toast({
          message: "您还未登录,前去登录",
          type: "error",
          onClose: function () {
            that.$router.push({
              path: "/login",
            });
          },
        });
      }
    },
    close() {
      let that = this;
      that.stock_today_status = false;
      that.stock_history_status = false;
    },
  },
  mounted: function () {
    let that = this;
    that.getCode(1);
    that.getNewsCategory();
  },
  beforeDestroy() {
    // clearInterval(this.chatTimer);
  },
};
</script>

<style scoped>
.stock_list {
  background-color: white;
  border-radius: 15px;
  padding: 20px 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.wrap {
  width: 100%;
  position: relative;
  background-color: #f7f7f7;
  padding-bottom: 20px;
  /*overflow:auto;*/
}
.wrap_img {
  width: 100%;
}
.winner_title {
  padding-top: 25px;
}
.winner_flag {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0px;
  color: #000000;
  border-right: 1px solid #ebedf0;
}
.winner_flag img {
  height: 20px;
}

.winner_para {
  font-size: 12px;
  margin-left: 6px;
}

.winner_tab_desc {
  margin: 0;
  font-size: 13px;
  text-align: center;
  padding: 25px 0px 10px;
}
.found_winner {
  width: 95%;
  margin: 0 auto;
}
.stock_name {
  height: 40px;
  text-align: center;
  border-radius: 50px;
  color: #333;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.stock_name p {
  margin: 0;
}
.more {
  line-height: 40px;
  text-align: center;
}
.found_winner_title {
  width: 100%;
}

.found_winner_title h4 {
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: black;
}
.stock_details p {
  margin: 0;
}
.stock_details {
  text-align: center;
  height: 40px;
  color: #333;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.found_winner_list {
  background: rgb(235, 235, 235);
  height: 40px;
  border-radius: 50px;
  margin-bottom: 10px;
  -moz-box-shadow: 5px 5px 5px #999; /* 老的 Firefox */
  box-shadow: 3px 3px 5px #999;
}
.found_winner_list:last-child {
  /*margin-bottom: 0;*/
}
.stockPopup {
  width: 90%;
  border-radius: 20px;
  padding-bottom: 20px;
}
.stock_more {
  width: 90%;
  margin: 0 auto;
  text-align: center;
  padding-bottom: 20px;
}
.stock_more h4 {
  font-size: 14px;
}
.stock_th {
  width: 100%;
}
.stock_td {
}
.stock_td td {
  border-bottom: 1px solid #999;
  padding-top: 10px;
}
.stock_td p {
  margin: 0;
  font-size: 14px;
}

.activeTabRed {
  background-color: red;
  color: #ffffff;
  padding: 10px 0px;
  margin: 0;
  border: none;
}

.activeTabRedFirst {
  background-color: red;
  color: #ffffff;
  border-radius: 15px 0px 0px 15px;
  padding: 10px 0px;
  margin: 0;
  border: none;
}

.activeTabRedLast {
  background-color: red;
  color: #ffffff;
  border-radius: 0px 15px 15px 0px;
  padding: 10px 0px;
  margin: 0;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/FoundWinners_old.vue